import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Errors } from 'react-redux-form'
import debounce from 'debounce'

import FacilityFilter from './AgencyFilter/IndexReactModal'

import { fetchFacilities } from '../../../actions/facilitiesActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons'

const connected = connect(store => {
  return {
    facilities: store.facilities.facilities,
    query: store.facilities.query,

    step1: store.availabilityRequestForm,
    step1Valid: store.forms.availabilityRequestForm.$form.valid,
    loading: store.facilities.fetching
  }
})
export class RequestFormStep1Facility extends Component {
  state = { search: this.props.query }

  componentWillMount() {
    this.doFetchFacilities()
  }

  doFetchFacilities = debounce(() => {
    const { search } = this.state
    this.props.dispatch(fetchFacilities(search))
  }, 400)

  handleSearchChange = event => {
    this.setState({ search: event.target.value }, () => {
      this.doFetchFacilities()
    })
  }

  render() {
    const { loading } = this.props

    return (
      <>
        <div className="text-xl font-bold">Campground or Facility to reserve at:</div>

        <div className="flex space-x-4 md:space-x-12 items-end mb-12 w-full lg:w-2/3">
          <div className="flex-grow">
            <div className="relative flex-grow">
              <input
                type="text"
                placeholder="Search..."
                onChange={this.handleSearchChange}
                className="w-full text-2xl p-2 border border-gray-300 rounded-md "
              />

              <div className="absolute right-0 top-0 mt-3 mr-4">
                <FontAwesomeIcon
                  icon={loading ? faSpinner : faSearch}
                  className={`text-3xl ${loading && 'animate-spin text-gray-300'}`}
                />
              </div>
            </div>
            <Errors
              model="availabilityRequestForm.facilityId"
              messages={{
                required: 'You must select a campground'
              }}
              component={props => (
                <div className="border border-green-500 text-green-500 pa4 rounded-md">{props.children}</div>
              )}
            />
          </div>

          <FacilityFilter />
        </div>
      </>
    )
  }
}
export default connected(RequestFormStep1Facility)
